import { alertRequest, body, request } from "services/request";

const resource = "api/organizationActivity";

const applyOrganizationActivityTarget = (params: {}) =>
    alertRequest(`${resource}/applyOrganizationActivityTarget`, body(params));

const getOrganizationActivityTarget = () => request(`${resource}/getOrganizationActivityTarget`, { method: "GET" });

const applyOrganizationStartedDate = (params: {}) =>
    alertRequest(`${resource}/applyOrganizationStartedDate`, body(params));

const getOrganizationStartedDate = () => request(`${resource}/getOrganizationStartedDate`, { method: "GET" });

export {
    applyOrganizationActivityTarget,
    getOrganizationActivityTarget,
    applyOrganizationStartedDate,
    getOrganizationStartedDate,
};
